import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addNewBerth,
  deleteScheduleData,
  fetchScheduleData,
  fetchScheduleDetails,
  updateLockFact,
  updatePosition,
  updateBerthRotation,
  fetchScheduleCompleteDetails,
} from "../../apis/voyageSchedule";

import type { BerthInput } from "../../utils/types/voyageSchedule";

export const fetchVoyageSchedule = createAsyncThunk(
  "voyageSchedule/fetchVoyageSchedule",
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      const schedules = await fetchScheduleData(id);
      return {
        data:schedules,
        jobId: id,
      };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateScheduleLockFact = createAsyncThunk(
  "voyageSchedule/updateScheduleLockFact",
  async (
    {
      id,
      data,
    }: { id: string; data: { berth_id: string; lock_fact: boolean } },
    { rejectWithValue }
  ) => {
    try {
      const result = await updateLockFact(id, data);
      return result;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateSchedulePosition = createAsyncThunk(
  "voyageSchedule/updateSchedulePosition",
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: {
        berthId: string;
        direction: "down" | "up";
        startIndex: number;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const result = await updatePosition(id, data);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateBerthRotationData = createAsyncThunk(
  "berthrotation/updateBerthrotation",
  async (
    {
      berth_id,
      job_id,
      data,
    }: {
      berth_id: string;
      job_id: string;
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const petsList = await updateBerthRotation(berth_id, job_id, data);
      return petsList;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteSchedule = createAsyncThunk(
  "voyageSchedule/deleteSchedule",
  async (
    { id, berthId }: { id: string; berthId: string },
    { rejectWithValue }
  ) => {
    try {
      const result = await deleteScheduleData(id, berthId);
      return {
        ...result,
        jobId: id,
      };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addBerth = createAsyncThunk(
  "voyageSchedule/addNewBerth",
  async (
    { id, data }: { id: string; data: BerthInput },
    { rejectWithValue }
  ) => {
    try {
      const result = await addNewBerth(id, data);
      return result;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const fetchVoyageScheduleDetails = createAsyncThunk(
  "voyageSchedule/fetchScheduleDetails",
  async ({ berthId }: { berthId: string }, { rejectWithValue }) => {
    try {
      const result = await fetchScheduleDetails(berthId);
      return result;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const fetchVoyageScheduleCompleteDetails = createAsyncThunk(
  "voyageSchedule/fetchScheduleCompleteDetails",
  async ({ berthId }: { berthId: string }, { rejectWithValue }) => {
    try {
      const result = await fetchScheduleCompleteDetails(berthId);
      return result;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);
